module.exports = __webpack_public_path__ + "static/img/equipment1new.5df913c9.png";